<template>
    <!-- HEAD -->
    <div class="container-xxl">
        <!-- titol -->
        <div class="row justify-content-between">
            <div class="col-12 col-lg-4 py-4 text-start">
                <p class="txtBlau2 my-0">{{ $t('site.avanzando-hacia-el-futuro')}}</p>
                <h2 class="text-uppercase">{{ $t('personas.personas')}}</h2>
            </div>
            <div class="col-6 text-start py-5 d-none d-lg-block">
                <h5>{{ $t('personas.el-grupo')}}</h5>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <!-- foto -->
        <div class="row">
            <div class="col-12 p-0 m-0 overflow-hidden">
                <img :src="`${publicPath}img/01avanzandoPersonas.jpg`" class="img-responsive" id="imgTransformacion">
            </div>
        </div>
        <div class="row d-block d-lg-none">
            <div class="col-11 mx-3 mt-3 text-start">
                <h5>{{ $t('personas.el-grupo')}}</h5>
            </div>
        </div>

    </div>
    <!-- end HEAD -->

    <!-- Content -->
    <div class="container-xxl">
        <div class="franjaODS d-none d-lg-block">
            <ul>
                <li class="odsTxt">{{ $t('site.ODS-impacto-directo')}}</li>
                <li><img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive"></li>
                <li style="width: 90px"></li>
                <li class="odsTxt">{{ $t('site.ODS-impacto-indirecto')}}</li>
                <li><img :src="`${publicPath}img/ods4_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods5_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods10_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods17_${locale}.gif`" class="img-responsive"></li>
            </ul>
        </div>
        <div class="franjaODS d-block d-lg-none">
            <div class="row justify-content-between p-0 m-0">
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>
                </div>
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods4_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods5_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods10_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods17_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>

                </div>
            </div>
        </div>

    </div>

    <div class="container-xxl">
        <div class="row justify-content-between g-3 mt-5 mt-lg-2">
            <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-5 pt-lg-0 text-start">
                    <h2 class="mb-5">{{ $t('personas.especializacion-programas')}}</h2>
                    <p class="txtGris">{{ $t('personas.La-formacion')}}</p>
                    <p class="txtGris"> &bull; {{ $t('personas.diseño-de-su-nueva-plataforma')}}</p>
                    <p class="txtGris"> &bull; {{ $t('personas.Seleccion-coordinadores')}}</p>
                    <p class="txtGris"> &bull; {{ $t('personas.Consolidacion-unidades')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="row">
                    <div class="col-6 m-auto aos-init aos-animate" data-aos="fade-down" data-aos-easing="easy-out" data-aos-duration="1000">
                        <img :src="`${publicPath}img/personasTit.png`" class="img-responsive">
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-lg-6 my-2 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="boxGris px-2 px-lg-5 py-5">
                            <div class="col-5 m-auto">
                                <img :src="`${publicPath}img/personasIcoA.png`" class="img-responsive">
                            </div>
                            <h2><AnimatedNumber
                                    ref='numA'
                                    :startAmount='0'
                                    :endAmount='132709'
                                    :duration='3'
                                    :separator=separator
                                    :decimals='0'
                                    :autoinit='true'
                            /></h2>
                            <h5 v-html="$t('personas.horas-formacion')"></h5>
                        </div>
                    </div>
                    <div class="col-6 col-lg-6 my-2 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="boxGris px-2 px-lg-5 py-5">
                            <div class="col-5 m-auto">
                                <img :src="`${publicPath}img/personasIcoB.png`" class="img-responsive">
                            </div>
                            <h2>{{ $t('personas.88')}}/<sub>10</sub></h2>
                            <h5 v-html="$t('personas.nivel-satisfaccion')"></h5>
                        </div>
                    </div>
                    <div class="col-12 my-2 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                        <img :src="`${publicPath}img/personasImgA.jpg`" class="img-responsive">

                    </div>
                </div>
            </div>
        </div>
        <hr class="my-5 borderGris">
    </div>

    <div class="container-xxl">
        <div class="row justify-content-between g-3 mt-5">
            <div class="col-12 col-lg-6 position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
                <img :src="`${publicPath}img/personasImgB_${locale}.jpg`" class="img-responsive">
            </div>
            <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-4 text-start">
                    <h2 class="mb-5">{{ $t('personas.Diversidad-igualdad-inclusividad')}}</h2>
                    <p class="txtGris">{{ $t('personas.RG-cuenta-empleados')}}</p>
                </div>
            </div>
        </div>
        <div class="row g-0 my-5 pt-5">
            <div class="col-12 col-lg-9 p-5 py-0 bg-dark text-start">
                <div class="col-12 col-lg-10 m-auto mt-5 p-3 py-0">
                    <h4 class="mb-3">{{ $t('personas.Nuevo-canal')}}</h4>
                    <p class="txtGris">{{ $t('personas.RG-ha-lanzado')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-3">
                <img :src="`${publicPath}img/personasImgC.jpg`" class="img-responsive">
            </div>
        </div>
    </div>

    <div class="container-fluid bg-dark my-0 my-lg-5 py-0 py-lg-5">
        <div class="container-xxl pb-5">
            <div class="row justify-content-between g-3 mt-2">
                <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="pt-0 text-start">
                        <h3 class="mb-5">{{ $t('personas.Roca-Group-Way')}}</h3>
                        <h4 class="txtGris">{{ $t('personas.el-objetivo')}}</h4>
                    </div>
                </div>
                <div class="col-12 col-lg-5 d-none d-lg-block">
                    <img :src="`${publicPath}img/personasWayA.png`" class="img-responsive aos-init aos-animate" data-aos-delay="100" data-aos="fade-up" data-aos-easing="easy-out" data-aos-duration="1000">
                    <img :src="`${publicPath}img/personasWayB_${locale}.png`" class="img-responsive aos-init aos-animate" data-aos-delay="300" data-aos="fade-right" data-aos-easing="easy-out" data-aos-duration="1000">
                    <img :src="`${publicPath}img/personasWayC_${locale}.png`" class="img-responsive aos-init aos-animate" data-aos-delay="500" data-aos="fade-left" data-aos-easing="easy-out" data-aos-duration="1000">
                    <img :src="`${publicPath}img/personasWayD_${locale}.png`" class="img-responsive aos-init aos-animate" data-aos-delay="700" data-aos="fade-right" data-aos-easing="easy-out" data-aos-duration="1000">
                </div>
            </div>
        </div>

    </div>
    <div class="container-fluid bg-dark p-0 m-0 d-block d-lg-none">
        <div class="container-xxl p-0 m-0">
            <div class="row p-0 m-0 g-0">
                <div class="col-12 col-lg-5 d-0 m-0">
                    <img :src="`${publicPath}img/personasWayAMobile.png`" class="img-responsive aos-init aos-animate" data-aos-delay="100" data-aos="fade-up" data-aos-easing="easy-out" data-aos-duration="1000">
                    <img :src="`${publicPath}img/personasWayBMobile_${locale}.png`" class="img-responsive aos-init aos-animate" data-aos-delay="300" data-aos="fade-right" data-aos-easing="easy-out" data-aos-duration="1000">
                    <img :src="`${publicPath}img/personasWayCMobile_${locale}.png`" class="img-responsive aos-init aos-animate" data-aos-delay="500" data-aos="fade-left" data-aos-easing="easy-out" data-aos-duration="1000">
                    <img :src="`${publicPath}img/personasWayDMobile_${locale}.png`" class="img-responsive aos-init aos-animate" data-aos-delay="700" data-aos="fade-right" data-aos-easing="easy-out" data-aos-duration="1000">
                </div>

            </div>
        </div>
    </div>

    <div class="container-xxl">
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-6 text-start aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <img :src="`${publicPath}img/personasImgD.jpg`" class="img-responsive">
                    <h4 class="my-5 col-11">{{ $t('personas.la-fuerza-equipo')}}</h4>
                    <p class="txtGris col-10">{{ $t('personas.la-planta-produccion')}}</p>
            </div>
            <div class="col-12 col-lg-6 text-start position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
                <img :src="`${publicPath}img/personasLabel.png`" class="img-responsive col-10 col-lg-7">
                <h4 class="my-5 col-12 col-lg-8">{{ $t('personas.RG-India')}}</h4>
                <p class="txtGris col-12 col-lg-10">{{ $t('personas.la-filial-grupo')}}</p>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="col-6 border-top border-dark">
                <localized-link to="/avanzando-hacia-el-futuro/sostenibilidad" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                    <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaLeft">
                            <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                        </svg>
                    </div>
                    <div class="col-6 col-lg-auto text-start p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.sostenibilidad") }}</h2>
                    </div>
                </localized-link>
            </div>
            <div class="col-6 border-top border-start border-dark">
                <localized-link to="/fundacion-we-are-water" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                    <div class="col-6 col-lg-auto text-end p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t('nav.fundacion-we-are-water')}}</h2>
                    </div>
                    <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaRight">
                            <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                        </svg>
                    </div>

                </localized-link>
            </div>
        </div>
    </footer>
    <!-- Footer -->
</template>
<script>
    import AnimatedNumber from "vue3-autocounter";
    export default {
        components: {
            AnimatedNumber
        },
        props: {
            hasChildren: Boolean
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                locale:this.$i18n.locale,
                separator: '.'
            }
        },
        mounted() {
            document.addEventListener('aos:in:counter', this.startCounter);
            if (this.$i18n.locale == "es") {
                this.separator = '.';
            } else {
                this.separator = ',';
            }
        },
        methods: {
            startCounter() {
                if (this.$refs.numA != null) {
                    this.$refs.numA.start();
                }
            }
        },
    }

</script>
